module.exports = __webpack_public_path__ + "img/flame.5a3ea111.svg";